// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var wrapperStyle = css({
  display: 'inline-flex',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  boxDecorationBreak: 'clone',
  borderRadius: "var(--ds-radius-small, 3px)",
  color: "var(--ds-text, #172B4D)",
  backgroundColor: "var(--ds-background-neutral, #091E420F)",
  transition: '0.1s all ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)"
  }
});